import { render, staticRenderFns } from "./ocrTemplateConfigDetail.vue?vue&type=template&id=3feeb044&scoped=true&"
import script from "./ocrTemplateConfigDetail.vue?vue&type=script&lang=js&"
export * from "./ocrTemplateConfigDetail.vue?vue&type=script&lang=js&"
import style0 from "./ocrTemplateConfigDetail.vue?vue&type=style&index=0&id=3feeb044&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feeb044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3feeb044')) {
      api.createRecord('3feeb044', component.options)
    } else {
      api.reload('3feeb044', component.options)
    }
    module.hot.accept("./ocrTemplateConfigDetail.vue?vue&type=template&id=3feeb044&scoped=true&", function () {
      api.rerender('3feeb044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/ocr/ocrTemplateConfigDetail.vue"
export default component.exports